import { Box, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Bar } from 'react-chartjs-2'
import { STATUS_COLORS } from '../statusPalette' // LAP — palette unifiée

function Chart2({ tasks, handleMesTaches }) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const optionsbar = {
    indexAxis: 'x',
    // responsive: true,
    aspectRatio: 1,
    maintainAspectRatio: false,
    onClick: function (evt, element) {
      if (element.length > 0) {
        let catName = data.labels[element[0].index]
        // console.log(catName)
        handleMesTaches(catName)
      }
    },
    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        display: false,
        events: [],
      },
      // tooltips: {
      //   callbacks: {
      //     label: function (tooltipItem) {
      //       return tooltipItem.yLabel
      //     },
      //     title: () => null,
      //   },
      // },
    },
    scales: {
      x: {
        stacked: true,
        ticks: { color: 'white' },
      },
      y: {
        stacked: true,
        ticks: { color: 'white' },
      },
    },
  }
  const [data, setRevData] = useState({
    labels: [
      'Important et urgent',
      'Important et non urgent',
      'Non-important et urgent',
      'Non-important et non-urgent',
    ],
    datasets: [
      {
        label: 'Non démarré',
        data: [5, 6, 2, 6],
        backgroundColor: [STATUS_COLORS.notStarted],
        borderColor: [STATUS_COLORS.notStarted],
        barThickness: 30,
        borderRadius: 4,
      },
      {
        label: 'En cours',
        data: [6, 3, 4, 8],
        backgroundColor: [STATUS_COLORS.inProgress],
        borderColor: [STATUS_COLORS.inProgress],
        barThickness: 30,
        borderRadius: 4,
      },
      {
        label: 'En retard',
        data: [9, 6, 7, 9],
        backgroundColor: [STATUS_COLORS.late],
        borderColor: [STATUS_COLORS.late],
        barThickness: 30,
        borderRadius: 4,
      },
      {
        label: 'Terminées',
        data: [9, 6, 1, 1],
        backgroundColor: [STATUS_COLORS.done],
        borderColor: [STATUS_COLORS.done],
        barThickness: 30,
        borderRadius: 4,
      },
    ],
  })
  useEffect(() => {
    let non = [0, 0, 0, 0]
    let encours = [0, 0, 0, 0]
    let enretard = [0, 0, 0, 0]
    let terminees = [0, 0, 0, 0]

    tasks.forEach((v) => {
      if (v.Priorite === 'Important et urgent') {
        if (v.Statut === 'Fait') {
          terminees[0] = terminees[0] + 1
        }
        if (v.Statut === 'En-Cours') {
          encours[0] = encours[0] + 1
        }
        if (v.Statut === 'En-retard') {
          enretard[0] = enretard[0] + 1
        }
        if ((v.Statut || '').trim() === 'Non démarré') {
          non[0] = non[0] + 1
        }
      }
      if (v.Priorite === 'Important et non urgent') {
        if (v.Statut === 'Fait') {
          terminees[1] = terminees[1] + 1
        }
        if (v.Statut === 'En-Cours') {
          encours[1] = encours[1] + 1
        }
        if (v.Statut === 'En-retard') {
          enretard[1] = enretard[1] + 1
        }
        if ((v.Statut || '').trim() === 'Non démarré') {
          non[1] = non[1] + 1
        }
      }
      if (v.Priorite === 'Non-important et urgent') {
        if (v.Statut === 'Fait') {
          terminees[2] = terminees[2] + 1
        }
        if (v.Statut === 'En-Cours') {
          encours[2] = encours[2] + 1
        }
        if (v.Statut === 'En-retard') {
          enretard[2] = enretard[2] + 1
        }
        if ((v.Statut || '').trim() === 'Non démarré') {
          non[2] = non[2] + 1
        }
      }
      if (v.Priorite === 'Non-important et non-urgent') {
        if (v.Statut === 'Fait') {
          terminees[3] = terminees[3] + 1
        }
        if (v.Statut === 'En-Cours') {
          encours[3] = encours[3] + 1
        }
        if (v.Statut === 'En-retard') {
          enretard[3] = enretard[3] + 1
        }
        if ((v.Statut || '').trim() === 'Non démarré') {
          non[3] = non[3] + 1
        }
      }
    })
    setRevData({
      labels: [
        'Important et urgent',
        'Important et non urgent',
        'Non-important et urgent',
        'Non-important et non-urgent',
      ],
      datasets: [
        {
          label: 'Non démarré',
          data: non,
          backgroundColor: [STATUS_COLORS.notStarted],
          borderColor: [STATUS_COLORS.notStarted],
          barThickness: 30,
        borderRadius: 4,
        },
        {
          label: 'En cours',
          data: encours,
          backgroundColor: [STATUS_COLORS.inProgress],
          borderColor: [STATUS_COLORS.inProgress],
          barThickness: 30,
        borderRadius: 4,
        },
        {
          label: 'En retard',
          data: enretard,
          backgroundColor: [STATUS_COLORS.late],
          borderColor: [STATUS_COLORS.late],
          barThickness: 30,
        borderRadius: 4,
        },
        {
          label: 'Terminées',
          data: terminees,
          backgroundColor: [STATUS_COLORS.done],
          borderColor: [STATUS_COLORS.done],
          barThickness: 30,
        borderRadius: 4,
        },
      ],
    })
  }, [tasks])
  const HorizontalBarChart = () => (
    <Box>
      <Bar data={data} options={optionsbar} />
    </Box>
  )
  return (
    <Box position={'relative'} height={350} width={'100%'}>
      {/* <Box width={isMobile ? '80vw' : '60vw'} height={350}> */}
      <Box width={'100%'} height={350}>
        <Bar data={data} width={'100%'} options={optionsbar} />
      </Box>
    </Box>
  )
}

export default Chart2
